import { FC } from "react";

import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  name: string;
  confirmCb: () => void;
}

export const ConfirmDeletePromptLibraryDialog: FC<Props> = ({ isOpen, setIsOpen, name, confirmCb }) => (
  <Dialog open={isOpen} onOpenChange={setIsOpen}>
    <DialogContent className="w-lg">
      <DialogTitle>Are you sure you want to delete {name}?</DialogTitle>
      <DialogDescription>Deleting this item will permanently remove it.</DialogDescription>

      <div className="ju mt-3 flex justify-end gap-2">
        <Button variant="outline" onClick={() => setIsOpen(false)}>
          Cancel
        </Button>
        <Button variant="destructive" onClick={() => confirmCb()}>
          Delete
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
